// extracted by mini-css-extract-plugin
module.exports = {"headMsg":"index-module--headMsg--3xIlQ","main":"index-module--main--3Z14U","busCardCtr":"index-module--busCardCtr--G7iJO"};